export const PRIMARY_LOGO_UPDATED_EVENT = 'dathent:primary-logo-updated';
